import {
  Grid,
  GridCol,
  GridRow,
  Section,
  SiteFooterV2,
  SiteFooterV2Utility,
  Text,
  VerticalSpace,
  Group,
  GroupItem,
  ButtonV2,
  Align,
  Link,
} from '@arc-ui/components';
import { ListDisclosure } from '../../atoms';
import { FooterComponentProps } from '../../../types';

const EEBFooterSmallDevice = ({
  itemGroups,
  socialLinks,
  copyrightNotice,
  socialData,
  isMobile,
  isTablet,
}: FooterComponentProps): React.ReactElement => {
  return (
    <>
      <SiteFooterV2 hideTopBorder>
        <div className="ee-footer-disclosure-content">
          {itemGroups?.map((group) => (
            <ListDisclosure
              summary={group.title.replace(' - Test', '')}
              isMobile={isMobile}
              isTablet={isTablet}
              key={group.title}
            >
              <Grid isFluid>
                <GridRow>
                  {group.linkListItems.map((item) => (
                    <GridCol key={item.title} xs={12} s={6} m={12}>
                      <Link
                        id="footer-disclosure-list-items"
                        size="m"
                        href={item.linkUrl}
                      >
                        {item.title}
                      </Link>
                    </GridCol>
                  ))}
                </GridRow>
              </Grid>
            </ListDisclosure>
          ))}
        </div>
        <VerticalSpace size="32" />
        <Grid isFluid isGutterless>
          <GridRow justify="center" align="center">
            <GridCol xs={10} s={10} m={8}>
              <Group growEqual>
                {socialLinks.map(({ linkUrl, icon, ariaLabel }) => (
                  <GroupItem key={linkUrl}>
                    <ButtonV2
                      id="social-links"
                      size="m"
                      icon={icon}
                      href={linkUrl}
                      buttonStyle="compact"
                      ariaLabel={ariaLabel}
                    />
                  </GroupItem>
                ))}
              </Group>
            </GridCol>
          </GridRow>
        </Grid>
        <VerticalSpace size="12" />
        <Align horizontal="center" vertical="center">
          <Text size="xs" align="center">
            {socialData?.legalInfo}
          </Text>
        </Align>
      </SiteFooterV2>
      <div className="ee-footer-utility">
        <Section>
          <SiteFooterV2Utility
            contentSlot={
              <Text size="m" isInline>
                <span className="arc-SiteFooterV2-copyrightSymbol">©</span>{' '}
                {copyrightNotice?.toUpperCase()}
              </Text>
            }
          />
        </Section>
      </div>
    </>
  );
};

export default EEBFooterSmallDevice;
